import { ApplicationError } from "./application-error.model";

export class CommunicationError extends ApplicationError {
    public static standardCommunicationErrorMessage = "Kommunikationsfel - vänligen försök igen om en liten stund.";

    constructor() {
        super(CommunicationError.standardCommunicationErrorMessage, 0);
    }
}